export interface VideoLayout {
  width: number;
  height: number;
  offsetX: number;
  offsetY: number;
}

/** Computes the effective video rect inside a container using `object-contain` (letterbox/pillarbox). */
export const calculateVideoLayout = (
  containerWidth: number,
  containerHeight: number,
  videoWidth: number,
  videoHeight: number,
): VideoLayout => {
  if (containerWidth <= 0 || containerHeight <= 0 || videoWidth <= 0 || videoHeight <= 0) {
    return { width: 0, height: 0, offsetX: 0, offsetY: 0 };
  }

  const containerAspect = containerWidth / containerHeight;
  const videoAspect = videoWidth / videoHeight;

  let effectiveWidth: number;
  let effectiveHeight: number;
  let offsetX: number;
  let offsetY: number;

  if (videoAspect > containerAspect) {
    // Wider than container: letterbox (bars top/bottom).
    effectiveWidth = containerWidth;
    effectiveHeight = containerWidth / videoAspect;
    offsetX = 0;
    offsetY = (containerHeight - effectiveHeight) / 2;
  } else {
    // Taller than container: pillarbox (bars left/right).
    effectiveHeight = containerHeight;
    effectiveWidth = containerHeight * videoAspect;
    offsetX = (containerWidth - effectiveWidth) / 2;
    offsetY = 0;
  }

  return {
    width: effectiveWidth,
    height: effectiveHeight,
    offsetX,
    offsetY,
  };
};
